import { TextAreaProps } from "antd/es/input";
import TextArea from "antd/es/input/TextArea";
import { CSSProperties } from "react";


export const CustomTextarea = (props?: TextAreaProps) => {
  const style: CSSProperties = {
    borderRadius: 24,
    padding: 24,
  }

  return <TextArea
    style={{ ...style, ...props?.style }}
    size={props?.size || "large"}
    autoSize={{ minRows: 3, maxRows: 12 }}
    {...props}
  />
}